import { IonIcon } from '@ionic/react'
import { earth, logInOutline } from 'ionicons/icons'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Button from '../../components/actions/Button'
import { AppContext } from '../../contexts/AppContext'
import { UserContext } from '../../contexts/UserContext'
import i18n from '../../i18n'
import PublicWrapper from '../../wrappers/publicWrapper/PublicWrapper'
import useBankAuthFlow from '../auth/components/useBankAuthFlow'
import LoadingPage from './LoadingPage'

const Welcome: React.FC = () => {
	const { isNativePlatform } = useContext(AppContext)
	const { setSkipLogin } = useContext(UserContext)

	const { t } = useTranslation('pages_welcome')
	const history = useHistory()

	const [language, setLanguage] = useState<'fi' | 'en'>('fi')

	const changeLanguage = () => {
		if (language === 'fi') {
			setLanguage('en')
			i18n.changeLanguage('en')
		} else {
			setLanguage('fi')
			i18n.changeLanguage('fi')
		}
	}

	const { startAuth, isLoading } = useBankAuthFlow()

	const skipLogin = async () => {
		setSkipLogin(true)

		history.push('/overview')
	}

	if (isLoading) {
		return <LoadingPage />
	}
	return (
		<>
			<PublicWrapper id='identification-chooser'>
				<div className='header'>
					<h1 className='text-text-dark dark:text-white'>{t('aloita')}</h1>
				</div>

				<div className='options'>
					<div className='option border border-brand-primary-100-light dark:border-brand-primary-100-dark'>
						<img
							src='assets/2024_logos/icon.png'
							alt='logo'
							className='max-w-[15vw] w-16 min-w-[10vw] hidden dark:block'
						/>
						<img
							src='assets/2024_logos/green-logo.png'
							alt='logo'
							className='max-w-[15vw] w-16 min-w-[10vw] block dark:hidden'
						/>
						<div className='name text-brand-primary-100-light dark:text-brand-primary-100-dark'>
							Älyenergia
						</div>
					</div>
				</div>

				{!isNativePlatform && (
					<div className='text-sm text-text-grey-300 dark:text-text-grey-100 pt-2 text-center'>
						{t('info1')}
					</div>
				)}
				{!isNativePlatform && (
					<div className='text-sm text-text-grey-300 dark:text-text-grey-100 pt-1 text-center'>
						{t('info2')}
					</div>
				)}
				{!isNativePlatform && (
					<div className='text-sm text-text-grey-300 dark:text-text-grey-100 pt-1 text-center'>
						{t('info3')}
					</div>
				)}
				<div className='description text-text-grey-300 dark:text-text-grey-100'>{t('info')}</div>

				<div className='buttons'>
					<Button onClick={startAuth}>{t('tunnistaudu')}</Button>
					<Button
						onClick={() => {
							skipLogin()
						}}
					>
						{t('loginAnonymous')}
					</Button>

					<Button routerLink='/login' className='hollow'>
						<div className='flex flex-row gap-2 items-center justify-center'>
							<IonIcon size='large' icon={logInOutline} />
							{t('kirjauduTunnuksilla')}
						</div>
					</Button>
				</div>
				<div
					onClick={changeLanguage}
					className='change-language hover gap-2 flex justify-center items-center mt-8 px-4 text-brand-primary-100-light dark:text-brand-secondary-100-dark'
				>
					<IonIcon className='text-3xl' icon={earth} />
					{language === 'fi' ? 'In English' : 'Suomeksi'}
				</div>
			</PublicWrapper>
		</>
	)
}

export default Welcome
